import { SVGProps } from 'react';

/**
 * Shield — "admin". Distinct from the gear that means "settings": administration and
 * preferences are different things, and two gears side by side read as a duplicate row.
 */
export const ShieldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-icon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    <path d="M12 2.75 4.75 5.9v5.35c0 4.4 2.9 8.5 7.25 10 4.35-1.5 7.25-5.6 7.25-10V5.9L12 2.75Z" />
  </svg>
);
